import { TAG_CODES } from "../../tag.config"

const GOM_TRAFFIC_NO_ENTRY = {
    type: 'path',
    tagCode: TAG_CODES.ROAD,
    withText: true,
    defaultText: 'No entry',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M100 50 206 50M140 30 160 70M140 70 160 30`,
}

export default GOM_TRAFFIC_NO_ENTRY